import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Head: {
    A_Transid: 0,
    A_Date: new Date(),
    A_Location: "",
    Loc_Name: "",
    A_Narration: "",
    A_Status: "ENTER",
    CreatedBy: "",
    CreatedDate: "",
    VendorName: "",
    VendorCd: "",
    isReloadSummary: false,
  }
};

const SliceItemListRequest = createSlice({
  name: "SliceItemListRequest",
  initialState: { value: initialState },

  reducers: {
    Head_Set: (state, action) => {
      state.value.Head = action.payload;
    },
    ItemListingRequest_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const { Head_Set,  ItemListingRequest_Init } =
  SliceItemListRequest.actions;
export default SliceItemListRequest.reducer;
